// actions/authActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const login = (email, phone, password) => async (dispatch) => {
  try {
    dispatch({ type: "LOGIN_REQUEST" });
    const { data } = await api.post("/auth/login", { email, phone, password });
    // Cookie auth works on web; storing the token too covers Electron /
    // Capacitor mobile, where cookies are unreliable (see utils/apiClient.js).
    if (data.token) localStorage.setItem("token", data.token);
    dispatch({ type: "LOGIN_SUCCESS", payload: data.user });
  } catch (err) {
    dispatch({
      type: "LOGIN_FAIL",
      payload: err.response?.data?.message || err.message,
    });
  }
};

// Same LOGIN_REQUEST/SUCCESS/FAIL flow as login(), but exchanges a
// Google idToken instead of email+password. The backend only logs in
// EXISTING accounts matched by email — see authController.js note.
export const googleLogin = (idToken) => async (dispatch) => {
  try {
    dispatch({ type: "LOGIN_REQUEST" });
    const { data } = await api.post("/auth/google", { idToken });
    if (data.token) localStorage.setItem("token", data.token);
    dispatch({ type: "LOGIN_SUCCESS", payload: data.user });
  } catch (err) {
    dispatch({
      type: "LOGIN_FAIL",
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: "LOAD_USER_REQUEST" });
    const { data } = await api.get("/auth/me");
    dispatch({ type: "LOAD_USER_SUCCESS", payload: data.user });
  } catch (err) {
    dispatch({ type: "LOAD_USER_FAIL", payload: err.response?.data?.message });
  }
};

export const logout = () => async (dispatch) => {
  await api.get("/auth/logout");
  localStorage.removeItem("token");
  dispatch({ type: "LOGOUT_SUCCESS" });
};

// OTP ని user email కి పంపిస్తుంది. Reducer మీద depend అవ్వకుండా,
// component లో నేరుగా వాడుకోడానికి result object ని return చేస్తుంది.
export const forgotPassword = (email) => async () => {
  try {
    const { data } = await api.post("/auth/forgot-password", { email });
    return { success: true, message: data.message };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

// OTP verify చేసి, new password set చేస్తుంది.
export const resetPassword = (email, otp, newPassword) => async () => {
  try {
    const { data } = await api.post("/auth/reset-password", {
      email,
      otp,
      newPassword,
    });
    return { success: true, message: data.message };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

// Admin-only: lists Google Sign-In accounts still waiting for a role.
export const getPendingUsers = () => async () => {
  try {
    const { data } = await api.get("/auth/admin/pending-users");
    return { success: true, pendingUsers: data.pendingUsers };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

// Admin-only: assigns a real role to a pending account.
export const assignUserRole = (userId, role) => async () => {
  try {
    const { data } = await api.put(`/auth/admin/assign-role/${userId}`, {
      role,
    });
    return { success: true, message: data.message };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
};
